import './auth-form-error.scss';

import type { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui';

/**
 * Форма входа или регистрации упала: ошибка внутри оверлея, а страница под ним остаётся
 * рабочей. «Повторить» перерисовывает форму, закрыть оверлей можно крестиком.
 */
const AuthFormError: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
  const { t } = useTranslation();

  return (
    <div className="auth-form-error" role="alert">
      <p className="auth-form-error__title">{t('errors.oops.title')}</p>
      <Button
        type="button"
        variant="filled-purple"
        fullWidth
        onClick={resetErrorBoundary}
      >
        {t('errors.retry')}
      </Button>
    </div>
  );
};

export default AuthFormError;
